"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var _toConsumableArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var d3_scale_1 = require("d3-scale");

var Scale;

(function (Scale) {
  /** Base scale class */
  var BaseScale =
  /*#__PURE__*/
  function () {
    function BaseScale() {
      _classCallCheck(this, BaseScale);
    }

    _createClass(BaseScale, [{
      key: "map",

      /** Get mapped values */
      value: function map(values) {
        var _this = this;

        return values.map(function (x) {
          return x == null ? null : _this.get(x);
        });
      }
    }]);

    return BaseScale;
  }();

  Scale.BaseScale = BaseScale;

  var LinearScale =
  /*#__PURE__*/
  function (_BaseScale) {
    _inherits(LinearScale, _BaseScale);

    function LinearScale() {
      _classCallCheck(this, LinearScale);

      return _possibleConstructorReturn(this, _getPrototypeOf(LinearScale).apply(this, arguments));
    }

    _createClass(LinearScale, [{
      key: "inferParameters",
      value: function inferParameters(values) {
        var scale = d3_scale_1.scaleLinear().domain([Math.min.apply(Math, _toConsumableArray(values)), Math.max.apply(Math, _toConsumableArray(values))]).nice();
        this.domainMin = scale.domain()[0];
        this.domainMax = scale.domain()[1];

        if (this.domainMax == this.domainMin) {
          this.domainMax = this.domainMin + 1;
        }
      }
    }, {
      key: "adjustDomain",
      value: function adjustDomain(options) {
        if (options.startWithZero == "default" || options.startWithZero == null) {
          if (this.domainMin > 0) {
            this.domainMin = 0;
          }
        } else if (options.startWithZero == "always") {
          this.domainMin = 0;
        }
      }
    }, {
      key: "get",
      value: function get(v) {
        return (v - this.domainMin) / (this.domainMax - this.domainMin);
      }
    }, {
      key: "ticks",
      value: function ticks() {
        var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
        var scale = d3_scale_1.scaleLinear().domain([this.domainMin, this.domainMax]);
        return scale.ticks(n);
      }
    }, {
      key: "tickFormat",
      value: function tickFormat() {
        var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
        var specifier = arguments.length > 1 ? arguments[1] : undefined;
        var scale = d3_scale_1.scaleLinear().domain([this.domainMin, this.domainMax]);
        return scale.tickFormat(n, specifier);
      }
    }]);

    return LinearScale;
  }(BaseScale);

  Scale.LinearScale = LinearScale;

  var LogarithmicScale =
  /*#__PURE__*/
  function (_BaseScale2) {
    _inherits(LogarithmicScale, _BaseScale2);

    function LogarithmicScale() {
      _classCallCheck(this, LogarithmicScale);

      return _possibleConstructorReturn(this, _getPrototypeOf(LogarithmicScale).apply(this, arguments));
    }

    _createClass(LogarithmicScale, [{
      key: "inferParameters",
      value: function inferParameters(values) {
        var scale = d3_scale_1.scaleLog().domain([Math.min.apply(Math, _toConsumableArray(values)), Math.max.apply(Math, _toConsumableArray(values))]).nice();
        this.domainMin = scale.domain()[0];
        this.domainMax = scale.domain()[1];

        if (this.domainMax == this.domainMin) {
          this.domainMax = this.domainMin + 1;
        }
      }
    }, {
      key: "get",
      value: function get(v) {
        return (Math.log(v) - Math.log(this.domainMin)) / (Math.log(this.domainMax) - Math.log(this.domainMin));
      }
    }, {
      key: "ticks",
      value: function ticks() {
        var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
        var scale = d3_scale_1.scaleLog().domain([this.domainMin, this.domainMax]);
        return scale.ticks(n);
      }
    }, {
      key: "tickFormat",
      value: function tickFormat() {
        var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
        var specifier = arguments.length > 1 ? arguments[1] : undefined;
        var scale = d3_scale_1.scaleLog().domain([this.domainMin, this.domainMax]);
        return scale.tickFormat(n, specifier);
      }
    }]);

    return LogarithmicScale;
  }(BaseScale);

  Scale.LogarithmicScale = LogarithmicScale;

  var DateScale =
  /*#__PURE__*/
  function (_LinearScale) {
    _inherits(DateScale, _LinearScale);

    function DateScale() {
      _classCallCheck(this, DateScale);

      return _possibleConstructorReturn(this, _getPrototypeOf(DateScale).apply(this, arguments));
    }

    _createClass(DateScale, [{
      key: "inferParameters",
      value: function inferParameters(values) {
        var scale = d3_scale_1.scaleUtc().domain([Math.min.apply(Math, _toConsumableArray(values)), Math.max.apply(Math, _toConsumableArray(values))]).nice();
        this.domainMin = scale.domain()[0].getTime();
        this.domainMax = scale.domain()[1].getTime();

        if (this.domainMax == this.domainMin) {
          this.domainMax = this.domainMin + 1000; // 1 second difference
        }
      }
    }, {
      key: "ticks",
      value: function ticks() {
        var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
        var scale = d3_scale_1.scaleUtc().domain([this.domainMin, this.domainMax]);
        return scale.ticks(n).map(function (x) {
          return x.getTime();
        });
      }
    }, {
      key: "tickFormat",
      value: function tickFormat() {
        var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
        var specifier = arguments.length > 1 ? arguments[1] : undefined;
        var scale = d3_scale_1.scaleUtc().domain([this.domainMin, this.domainMax]);
        var fmt = scale.tickFormat(n, specifier);
        return function (t) {
          return fmt(new Date(t));
        };
      }
    }]);

    return DateScale;
  }(LinearScale);

  Scale.DateScale = DateScale;

  var CategoricalScale =
  /*#__PURE__*/
  function (_BaseScale3) {
    _inherits(CategoricalScale, _BaseScale3);

    function CategoricalScale() {
      _classCallCheck(this, CategoricalScale);

      return _possibleConstructorReturn(this, _getPrototypeOf(CategoricalScale).apply(this, arguments));
    }

    _createClass(CategoricalScale, [{
      key: "inferParameters",
      value: function inferParameters(values) {
        var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "alphabetically";
        var vals = new Map();
        var domain = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var v = _step.value;

            if (v == null) {
              continue;
            }

            v = v.toString();

            if (vals.has(v)) {
              vals.set(v, vals.get(v) + 1);
            } else {
              vals.set(v, 1);
              domain.push(v);
            }
          } // Sort alphabetically

        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        switch (order) {
          case "alphabetically":
            {
              domain.sort(function (a, b) {
                return a < b ? -1 : 1;
              });
            }
            break;

          case "occurrence":
            {
              domain.sort(function (a, b) {
                var ca = vals.get(a);
                var cb = vals.get(b);

                if (ca != cb) {
                  return cb - ca;
                } else {
                  return a < b ? -1 : 1;
                }
              });
            }
            break;

          case "order":
            {}
            break;
        }

        this.domain = new Map();

        for (var i = 0; i < domain.length; i++) {
          this.domain.set(domain[i], i);
        }

        this.length = domain.length;
      }
    }, {
      key: "get",
      value: function get(v) {
        return this.domain.get(v);
      }
    }]);

    return CategoricalScale;
  }(BaseScale);

  Scale.CategoricalScale = CategoricalScale;
})(Scale = exports.Scale || (exports.Scale = {}));